// components/editor/use-is-mobile.ts
import { useSyncExternalStore } from "react"

export const MOBILE_QUERY = "(max-width: 768px)"

function subscribe(cb: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {}
  const mql = window.matchMedia(MOBILE_QUERY)
  mql.addEventListener("change", cb)
  return () => mql.removeEventListener("change", cb)
}

// A real MediaQueryList mutates its own `.matches` before firing `change`, so
// reading it here always reflects the current viewport.
function getSnapshot(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false
  return window.matchMedia(MOBILE_QUERY).matches
}

/** Reactive mobile-breakpoint flag. Single source of truth for the editor's
 *  desktop/mobile presentation fork. Returns false during SSR and in jsdom. */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false)
}
